import type { DSSetup } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';

import type { Args as BaseArgs } from 'webapp/components/common/master-filter';
import CommonMasterFilterComponent from 'webapp/components/common/master-filter';

import type { BoardState } from 'webapp/models-custom';

interface Args extends BaseArgs {
	boardState: BoardState;
}

export default class BoardMasterFilterComponent extends CommonMasterFilterComponent<Args> {
	origin = 'master';

	get dimensions(): string[] | undefined {
		return this.args.boardState.selectedMasterDimensions;
	}

	get filters(): DSSetup.MetricSetupFiltersData | null | undefined {
		return this.args.boardState.selectedMasterFilters;
	}

	get metricDataItems(): DSSetup.MetricData[] {
		return this.args.boardState.metricData;
	}

	get metricSetupDataItems(): DSSetup.MetricSetupData[] {
		return this.args.boardState.metricSetupDataArray;
	}

	get allowAdvancedSetup(): boolean {
		return this.metricSetup.allowDimensions && this.args.boardState.allowAdvancedSetup;
	}

	get allowAdvancedFilters(): boolean {
		return this.metricSetup.allowDimensions && this.args.boardState.allowAdvancedFilters;
	}

	override get preferredPopupDirections() {
		return [Direction.UP, Direction.DOWN];
	}
}
